(function () {
    'use strict';

    angular
        .module('recomControllers')
        .controller('GovernanceProcessEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'notificationService', 'businessUnit', 'fiscalYears', 'governanceProcess'];

    function Controller($scope, $state, topBarService, notificationService, businessUnit, fiscalYears, governanceProcess) {
        topBarService.setTitleAndIcon('Governance Process Management', 'fa fa-road');

        $scope.businessUnit      = businessUnit;
        $scope.fiscalYears       = fiscalYears;
        $scope.governanceProcess = governanceProcess;

        $scope.goToGovernanceProcessList = function (replace) {
            $state.go('recom.listGovernanceProcess', {replace: replace});
        };

        if($state.is('recom.editGovernanceProcess') && !governanceProcess) {
            notificationService.warn('Couldn\'t find Governance Process or Governance Process is closed.');
            $scope.goToGovernanceProcessList(true);
        }

        if ($scope.governanceProcess.GovernanceProcessID && !$scope.governanceProcess.IsActive) {
            // Prevent editing closed gov processes
            $scope.goToGovernanceProcessList(true);
        }
    }
})();